"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeGuideDrawer = void 0;
const react_1 = __importDefault(require("react"));
const Cancel_1 = __importDefault(require("@kyruus/react-ikons/Cancel"));
const PracticeGuide_1 = require("../PracticeGuide");
const PracticeGuideDrawer_styles_1 = require("./PracticeGuideDrawer.styles");
const PracticeGuideDrawer = (_a) => {
    var { title, practiceGuide, labels, onClose, open, onActivateTab } = _a, rest = __rest(_a, ["title", "practiceGuide", "labels", "onClose", "open", "onActivateTab"]);
    return (react_1.default.createElement(PracticeGuideDrawer_styles_1.Drawer, Object.assign({ anchor: "right", variant: "temporary", transitionDuration: { enter: 350, exit: 500 }, open: open, onClose: onClose }, rest),
        react_1.default.createElement(PracticeGuideDrawer_styles_1.Title, null, title),
        react_1.default.createElement(PracticeGuideDrawer_styles_1.CloseButton, { mode: "flat", onClick: onClose },
            react_1.default.createElement(Cancel_1.default, { size: "24px" })),
        react_1.default.createElement(PracticeGuideDrawer_styles_1.Separator, null),
        react_1.default.createElement(PracticeGuideDrawer_styles_1.Content, null, practiceGuide && (react_1.default.createElement(PracticeGuide_1.PracticeGuide, { headerElement: "h2", practiceGuide: practiceGuide, labels: labels, onActivate: onActivateTab })))));
};
exports.PracticeGuideDrawer = PracticeGuideDrawer;
//# sourceMappingURL=PracticeGuideDrawer.js.map